<svg width="90px" height="90px" viewBox="0 0 90 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="shield-types">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path [attr.d]="svg" fill="#ffffff"></path>
    </g>
</svg>
